import { Link } from 'react-router-dom';
import { getAllCategories } from '@/lib/content';

const EXTRA_LINKS = [
  { name: '最新资讯', desc: '第一时间掌握动态', to: '/news', icon: 'ri-flashlight-line' },
];

export default function CategoryQuickLinks() {
  const categories = getAllCategories();

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 text-center">
        <span className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
          QUICK ACCESS
        </span>
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">分类快捷入口</h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
          按兴趣直达你想看的内容板块，快速定位剧情、资讯与专题花絮。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-accent-500">
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{cat.name}</h3>
            <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
            <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
              进入分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}

        {EXTRA_LINKS.map((link) => (
          <Link
            key={link.name}
            to={link.to}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-500 text-background-50 transition-colors group-hover:bg-accent-500">
              <i className={`${link.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{link.name}</h3>
            <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{link.desc}</p>
            <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
              立即浏览
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}